<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'branch/index' }">
                                Cabang
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Create New Cabang
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Profil Cabang
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="form-group">
                                <label class="font-weight-medium required">Nama Cabang</label>
                                <input v-model="form.name" class="form-control form-control-sm" placeholder="Nama Cabang" required />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Logo Cabang</label>
                                <input id="image" type="file" class="form-control" v-on:change="preview" placeholder="Choose File" accept="image/*" required/>
                                <label for="image" class="form-control form-control-sm">
                                    <button type="button" class="btn btn-danger btn-sm font-weight-bold">
                                        Choose File
                                    </button> 
                                </label>
                                <img v-bind:src="imagePreview" class="img-fluid mt-2 w-100" />
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Alamat Cabang</label>
                                <textarea v-model="form.address" class="form-control form-control-sm" placeholder="Alamat Cabang" spellcheck="false" required></textarea>
                            </div>
                            <div class="form-group">
                                <label class="font-weight-medium required">Jenis Cabang</label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="type" v-model="form.isPrimary" true-value="1" false-value="0" />
                                    <label class="form-check-label" for="type">
                                        {{ parseInt(form.isPrimary) ? 'Utama' : 'Mitra' }}
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="type" v-model="form.isHidden" true-value="1" false-value="0" />
                                    <label class="form-check-label" for="type">
                                        {{ parseInt(form.isHidden) ? 'PP' : 'Non PP' }}
                                    </label>
                                </div>
                            </div>
                            <div class="pt-3 text-center">
                                <button type="submit" class="btn btn-danger btn-sm px-5">
                                    Save
                                </button>
                                <router-link v-bind:to="{ name: 'branch/index' }" exact class="btn btn-outline-danger btn-sm px-5 ml-3">
                                    Cancel
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "BranchAdd",
        data() {
            return {
                form: {
                    name: '',
                    address: '',
                    isPrimary: 1,
                    isHidden: 0,
                    image: ''
                },
                imagePreview: ''
            };
        },
        methods: {
            save() {
                var formData = new FormData();
                for (var attribute in this.form) {
                    formData.set(attribute, this.form[attribute]);
                }
                this.axios.post(process.env.API_URL + '/branch', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'branch/view', params: {id: response.data.data.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            }
        },
        mounted() {
            document.title = 'Add Branch - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/branch/Add.vue